import { configureStore } from "@reduxjs/toolkit";
import contractBetReducer from "./contractBetSlice";
import contractPricingReducer from "./contractPricing/contractPricingSlice";

export default configureStore({
    reducer: {
        betStore: contractBetReducer,
        contractPricing: contractPricingReducer
    }
});